// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"113":"70c4088312383ad8","767":"f212e5a7574f0261"}[chunkId] + ".js";
};